import {
  Button,
  Modal,
  Switch,
} from "@mui/joy";
import { WHITE } from "../../../../../appConstants";
import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import toast from "react-hot-toast";
type Parameter = {
  id: number;
  parameter_name: string;
  backend_parameter_name: string;
  toggle: boolean;
  position: number;
};
type AddKeywordTypeProps = {
  setToggle: Dispatch<SetStateAction<boolean>>;
  parametersData: Parameter[];
  exportfunc : (args: string[]) => void;
  loading: boolean;
};

const ComparisonExportSelectionModal: React.FC<AddKeywordTypeProps> = ({
  setToggle,
  parametersData,
  exportfunc,
  loading
}) => {
  const [initial_parameters, setInitial_parameters] = useState<Parameter[]>([]);

  const parameterSwitchChangeHandler = (parameter_id: Number) => {
    const Exist = initial_parameters.find(
        (d: Parameter) => d?.id === parameter_id
      )?.toggle;

      let newParameterArr = [] as Parameter[];
      if (Exist) {
        if (initial_parameters?.filter((item) => item.toggle).length === 1) {
          toast.error("Minimum 1 Parameter to be present");
          return;
        } else if (initial_parameters.filter((item) => item.toggle).length > 1) {
          newParameterArr = initial_parameters.map((d) =>
            d.id === parameter_id ? { ...d, toggle: false } : d
          );
        }
      } else {
        newParameterArr = initial_parameters.map((d) =>
          d.id === parameter_id ? { ...d, toggle: true } : d
        );
      }
      setInitial_parameters(newParameterArr);
  }

  const areAllTogglesTrue = (dataArray : Parameter[]) => {
    return dataArray.every(item => item.toggle !== true);
  };
  
  const exportHandler = () => {
    let selected_parameters =  initial_parameters?.filter((p) => p?.toggle === true)?.map((p) => p?.backend_parameter_name);
    exportfunc(selected_parameters);
  }

  useEffect(() => {
    setInitial_parameters(parametersData);
  }, []);

  return (
    <Modal
      open={true}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      className="h-full"
    >
      <div className="relative">
        <div
          style={{
            width: 550,
            height: 420,
            paddingLeft: 40,
            paddingRight: 40,
            paddingBottom: 40,
            paddingTop: 40,
            backgroundColor: `${WHITE.W_100}`,
          }}
          className="flex flex-col items-center justify-between rounded-[16px] gap-10"
        >
          <div className="flex flex-col w-full">
            <div
              className="self-stretch"
              style={{
                color: `#1C1C1E`,
                fontSize: 20,
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "26px",
              }}
            >
              Select Export Preferences
            </div>
            <div
              className="self-stetch"
              style={{
                color: `#97979A`,
                fontSize: 14,
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "22px",
              }}
            >
              Export the table or customise with specific parameters
            </div>
          </div>
          <div className="flex flex-col w-full gap-1">
            {initial_parameters.length > 0 &&
              initial_parameters.map((p: Parameter) => (
                <div
                  className="flex justify-between items-center h-[40px] gap-2 self-stretch"
                  key={p?.backend_parameter_name}
                >
                  <div className="flex items-center gap-1">
                    <div
                      className=""
                      style={{
                        fontFamily: "Inter",
                        paddingLeft: "5px",
                        color: "#1C1C1E",
                        fontSize: "14px",
                        fontWeight: p?.toggle ? 600 : 400,
                        lineHeight: "18px",
                      }}
                    >
                      {p?.parameter_name}
                    </div>
                  </div>
                  <Switch
                    checked={p?.toggle}
                    onChange={() =>
                      parameterSwitchChangeHandler(p?.id)
                    }
                  />
                </div>
              ))}
          </div>
          <div className="flex items-start justify-center gap-4 self-stretch">
            <Button
              color="neutral"
              sx={{
                height: "40px",
                width: "50%",
                backgroundColor: "#FFF",
                ":hover": {
                  backgroundColor: "#FFF",
                },
                color: "#1C1C1E",
                borderRadius: "8px",
                border: "1px solid #F2F2F5",
                padding: "0px 8px",
                fontSize: "14px",
                fontWeight: 700,
                lineHeight: "18px",
              }}
              onClick={() => setToggle(false)}
            >
              Cancel
            </Button>
            <Button
              onClick={exportHandler}
              sx={{
                height: "40px",
                width: "50%",
                backgroundColor: "#1565C0",
                color: "#FFF",
                borderRadius: "8px",
                padding: "0px 8px",
                fontSize: "14px",
                fontWeight: 700,
                lineHeight: "18px",
              }}
              disabled = {areAllTogglesTrue(initial_parameters)}
              loading={loading}
            >
              Export
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ComparisonExportSelectionModal;
